<template>
  <section>
    <validation-observer ref="form">
      <div v-if="confirmationMode && !confirmationModeReadOnly" class="">
        <h3 id="confirmation-mode">Confirmação de pedido</h3>
        <h4>Como vai ficar seu tapete:</h4>
      </div>
      <div v-for="(product, index) in collection" :key="index">
        <hr v-if="index > 0" />
        <div :id="`top-widget-${index}`" class="flex columns top-widget">
          <!-- photo -->
          <div :id="`top-widget-photo-${index}`" class="item photo simulator" :class="{
              hasAcessory: checkExistAcessory(product.pets_data),
              pet_quantity_1: product.quantity_pets == '1',
              pet_quantity_2: product.quantity_pets == '2',
              pet_quantity_3: product.quantity_pets == '3',
              pet_quantity_4: product.quantity_pets == '4',
              pet_quantity_5: product.quantity_pets == '5',
              pet_quantity_6: product.quantity_pets == '6',
              pet_quantity_7: product.quantity_pets == '7',
              pet_quantity_8: product.quantity_pets == '8',
              clean_bg: product.color_bg == 'Cinza 2' || product.color_bg == 'Areia 2'
            }">
            <div class="promo-banner dance-pet" :class="{ 'promo-confirmation': confirmationMode}">
              <img src="@/assets/imgs/promo.png">
            </div>
            <div
            v-if="collection.length > 1 && !confirmationMode"
            @click="deleteProduct(index)"
            class="btn delete-btn secondary"
            >
              <b>X</b>
            </div>
            <div class="simulator-name">{{ product.first_info }}</div>
            <div v-if="product.has_subtitle" class="simulator-subname">{{ product.pet_name }}</div>
            <div
              class="simulator-position"
              :class="{
                pet_1: product.quantity_pets == '1',
                pet_2: product.quantity_pets == '2',
                pet_3: product.quantity_pets == '3',
                pet_4: product.quantity_pets == '4',
                pet_5: product.quantity_pets == '5',
                pet_6: product.quantity_pets == '6',
                pet_7: product.quantity_pets == '7',
                pet_8: product.quantity_pets == '8',
              }"
            >
            <div class="list-pets">
              <div v-for="(pet, indexPet) in product.pets_data" :key="indexPet" :class="`simulator-pet-${indexPet}`">
                <div class="name-simulator">
                  <span v-if="pet.pet_name">
                    {{ pet.pet_name }}
                  </span>
                </div>
                <div v-if="pet.pet_photo" class="photo-simulator" >
                  <img :src="decodePhotoUrl(pet, pet.pet_photo)"/>
                </div>
                <div v-if="pet.aurela" class="aurela-pet" style="">
                  <img :src="decodeAurela(product.quantity_pets)">
                </div>
                <div v-if="pet.oculos" class="oculos-pet" style="">
                  <img :src="decodeOculos(product.quantity_pets)">
                </div>
                <div v-if="pet.laco" class="laco-pet" style="">
                  <img :src="decodeLaco(product.quantity_pets)">
                </div>
                <div v-if="pet.gravata" class="gravata-pet" style="">
                  <img :src="decodeGravata(product.quantity_pets)">
                </div>
              </div>
            </div>
            </div>
            <img class="simulator-photo" :src="decodeBackground(product)" />
          </div>
          <!-- data -->
          <div v-if="!confirmationMode" class="item max-width">
            <div class="flex columns">
              <!-- informations -->
              <div class="item">
                <div class="flex columns">
                  <div class="item">
                    <h2>
                      <b>SEMANA DO CONSUMIDOR!</b>
                      <span style="font-size: 37px; font-weight: 700">
                        Tapete meuPET™
                      </span>
                    </h2>
                  </div>
                  <div class="item">
                    <h2 class="current-price banner-animate">
                      <span
                        style="position:relative; color: #333; font-size: 24px; font-weight: 400"
                      >
                        <span
                          style=" position: absolute; border-bottom: 4px solid red; width: 100%; top: 33%; left: 15px; transform: rotate(-22deg)"
                        ></span>
                        R$ {{ parseInt(product.price) * 2 }}
                      </span>
                      <span
                        style="color: #333; font-size: 24px; font-weight: 400"
                        >por</span
                      >
                      R$
                      {{ product.price }}
                    </h2>
                  </div>
                  <div class="item">
                    <h2>
                      ou apenas <b>12x</b> de
                      <b>
                        <span class="current-price-parcela"
                          >R$ {{ product.price_parcel }}
                        </span></b
                      >
                      <!-- <span class="nojuros">sem juros!</span> -->
                    </h2>
                  </div>
                  <small><span>*Promoção válida enquanto durar o estoque.</span></small>
                </div>
              </div>
              <hr />

              <!-- size -->
              <div  class="item">
                <div class="flex columns">
                  <div class="item">
                    <h3>
                      <span style="font-weight:400">Tamanho: </span>
                      <span id="current-size">{{ product.size }}</span>
                    </h3>
                  </div>
                  <div v-if="sizes && sizes.length > 1" class="item">
                    <div class="flex wrap">
                      <div v-for="(size, indexSize) in sizes" :key="indexSize">
                        
                        <div
                          :class="{
                            active: product.size == size,
                            'no-margin-left': indexSize == 0,
                            'disabled': size =='20x30cm',
                          }"
                          class="item btn w-size flex columns"
                          @click="changeSizeProduct(index, size)"
                        >
                          {{ size }}
                          <span v-if="size =='20x30cm'">(Esgotado)</span>
                        </div>
                      </div>
                    </div>
                    <div v-if="false" @click="openSizeModal()" class="diff-size flex wrap" style="cursor: pointer;">
                      <small>(Clique Aqui) para ver a diferença dos tamanhos.</small>
                    </div>
                    
                    <div v-if="showModalSize" class="modal-size flex center" @click="openSizeModal()">
                      <div class="box flex center">
                        <div class="box-content flex columns">
                          <div>
                            <img src="@/assets/imgs/TAMANHOS.jpeg">
                          </div>
                          <div>
                            <div @click.stop="openSizeModal()"  class="btw w-size txt-center active">
                              FECHAR (X)
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- color -->
              <div  class="item">
                <div class="flex columns">
                  <div class="item">
                    <h3>
                      <span style="font-weight:400">Cor: </span>
                      <span id="current-size">{{ product.color_bg }}</span>
                    </h3>
                  </div>
                  <div v-if="colors && colors.length > 1" class="item">
                    <div class="flex wrap">
                      <div v-for="(color, indexColor) in colors" :key="indexColor">
                        
                        <div
                          :class="{
                            active: product.color_bg == color,
                            'no-margin-left': indexColor == 0,
                          }"
                          class="item btn w-size flex columns"
                          @click="changeColorProduct(index, color)"
                        >
                          {{ color }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <!-- quantity pets -->
              <div class="item">
                <div class="flex columns">
                  <div class="item">
                    <h3>
                      <span style="font-weight:400">Quantidade de Figuras: </span>
                      <span id="current-size">{{ product.quantity_pets }}</span>
                    </h3>
                  </div>
                  <div class="item">
                    <div class="flex wrap">
                      <div v-for="(qp, indexQp) in quantity_pets" :key="indexQp">
                        <div
                          :class="{
                            active: product.quantity_pets == qp,
                            'no-margin-left': indexQp == 0,
                          }"
                          class="item btn w-size"
                          @click="changeQuantityPet(index, qp)"
                        >
                          {{ qp }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item" style="margin-top: 20px">
                <div v-if="product.has_title" >
                  <div class="item">
                      <h3>Frase Principal:</h3>
                  </div>
                  <div class="item">
                    <input
                      v-model="product.first_info"
                      @keydown="ignoreSystemEmojis($event)"
                      name="custom-sub-title"
                      type="text"
                      maxlength="15"
                    />
                  </div>
                </div>
                <div>
                  <div class="flex columns">
                    <div class="item">
                      <div class="flex columns item btn w-size" @click="addTitle(product)">
                        <div v-if="!product.has_title">
                          <div>
                            Adicionar Frase Princípal
                          </div>
                          <div>
                            <small>Sem custo adicional</small>
                          </div>
                        </div>
                        <div v-else>
                          <div>
                            <i data-v-03021b48="" class="far fa-trash-alt" aria-hidden="true"></i> Remover Frase
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

              <!-- frase -->
              <div v-if="showSubTitle" class="item" style="margin-top:20px">
                <div v-if="product.has_subtitle" :key="product.has_subtitle" style="margin-top: 20px">
                  <div class="item">
                      <h3>Personalizar Frase:</h3>
                  </div>
                  <div class="item">
                    <input
                      v-model="product.pet_name"
                      @keydown="ignoreSystemEmojis($event)"
                      name="custom-sub-title"
                      type="text"
                      maxlength="50"
                    />
                  </div>

                </div>
                <div class="flex columns">
                  <div class="item">
                    <div class="flex columns item btn w-size" @click="addPersonalizationFrase(product)">
                      <div v-if="!product.has_subtitle">
                        <div>
                          Adicionar Frase Personalizada
                        </div>
                        <div>
                          <small>Sem custo adicional</small>
                        </div>
                      </div>
                      <div v-else>
                        <div>
                          <i data-v-03021b48="" class="far fa-trash-alt" aria-hidden="true"></i> Remover Frase
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>

              <!-- customization -->
              <div class="item">
                <div class="flex columns">
                  <div v-for="(pet_data, indexQt) in product.pets_data" :key="indexQt">
                    <validation-provider
                      :vid="`pet-name-${index}`"
                      name="Nome do PET"
                      rules="max:10"
                      v-slot="{ errors }"
                    >
                      <div class="group-input" :class="{ errors: errors[0] }">
                        <div class="item">
                          <h3>Nome do PET ({{indexQt + 1}}):</h3>
                        </div>
                        <div class="item">
                          <input
                            v-model="pet_data.pet_name"
                            name="custom-name-dog"
                            type="text"
                            maxlength="10"
                          />
                          <span class="erros-alert">{{ errors[0] }}</span>
                        </div>
                      </div>
                    </validation-provider>

                    <!-- dog or cat? -->
                    <div class="flex wrap">
                      <div v-for="(petType, indexType) in ['CACHORRO', 'GATO', 'COELHO', 'CRIANCA', 'ADULTO']" :key="indexType" class="flex-1">
                        <div
                          :class="{
                            active: pet_data.pet_type == petType,
                            'no-margin-left': indexType == 0,
                          }"
                          class="item btn w-size"
                          @click="changePetType(pet_data, petType)"
                        >
                          {{ petType !== 'CRIANCA' ? petType : 'CRIANÇA' }}
                        </div>
                      </div>
                    </div>
                    
                    <!-- dog category -->
                    <div v-if="pet_data.pet_type == 'CACHORRO'" class="item">
                      <p>Primeira letra da raça:</p>
                      <div class="flex wrap">
                        <div v-for="(petClass, indexClass) in ['A', 'B', 'C', 'D-F', 'G-H', 'I-N', 'O-R', 'S-Y', 'TODOS']" :key="indexClass">
                          <div
                            :class="{
                              active: pet_data.pet_class == petClass,
                              'no-margin-left': indexClass == 0,
                            }"
                            class="item btn w-size"
                            @click="changePetClass(pet_data, petClass)"
                          >
                            {{ petClass }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- cat category -->
                    <div v-else-if="pet_data.pet_type =='GATO'" class="">
                      <p>Tipo de pelo:</p>
                      <div class="flex wrap">
                        <div v-for="(petClass, indexClass) in ['PELO-LONGO', 'PELO-CURTO', 'MALHADO', 'EGIPSIO', 'TODOS']" :key="indexClass">
                          <div
                            :class="{
                              active: pet_data.pet_class == petClass,
                              'no-margin-left': indexClass == 0,
                            }"
                            class="item btn w-size"
                            @click="changePetClass(pet_data, petClass)"
                          >
                            {{ petClass == 'EGIPSIO' ? 'EGIPCIO': petClass == 'MALHADO' ? 'PELO-CURTO-ORELHA-BAIXA' : petClass }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- rabbit category -->
                    <div v-else-if="pet_data.pet_type == 'COELHO'" class="">
                      <p>Tipo de pelo:</p>
                      <div class="flex wrap">
                        <div v-for="(petClass, indexClass) in ['TODOS']" :key="indexClass">
                          <div
                            :class="{
                              active: pet_data.pet_class == petClass,
                              'no-margin-left': indexClass == 0,
                            }"
                            class="item btn w-size"
                            @click="changePetClass(pet_data, petClass)"
                          >
                            {{ petClass == 'EGIPSIO' ? 'EGIPCIO': petClass == 'MALHADO' ? 'PELO-CURTO-ORELHA-BAIXA' : petClass }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- pet photo -->
                    <div v-if="pet_data.pet_class">
                      <p>Figura:</p>
                      <div  class="pet-photos-list">
                        <div class="flex wrap">
                          <div v-for="(petPhoto, indexPhoto) in decodePetPhotos(pet_data.pet_type, pet_data.pet_class)" :key="indexPhoto">
                            <div
                              :class="{
                                active: pet_data.pet_photo == petPhoto,
                                'no-margin-left': indexPhoto == 0,
                              }"
                              class="item btn-photo"
                              @click="pet_data.pet_photo = petPhoto"
                              style="max-width:100px"
                            >
                              <img :src="decodePhotoUrl(pet_data, petPhoto)" style="max-width: 100px;"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- pet eye photo -->
                    <div v-if="pet_data.pet_photo && pet_data.pet_type === 'GATO'">
                      <p>Cor do olho:</p>
                      <div  class="pet-photos-list">
                        <div class="flex wrap">
                          <div v-for="(petEyer, indexEyer) in ['VERDE', 'AZUL', 'AMARELO']" :key="indexEyer">
                            <div
                              :class="{
                                active: pet_data.pet_eyer == petEyer,
                                'no-margin-left': indexEyer == 0,
                              }"
                              class="item btn-photo"
                              @click="pet_data.pet_eyer = petEyer"
                            >
                              <div class="box-eyer" :class="{ eyergreen: petEyer === 'VERDE', eyerblue: petEyer === 'AZUL', eyeryellow: petEyer === 'AMARELO'}"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style="margin-top: 12px"><small>A cor do olho não vai ser alterada no simulador. Na confirmação do pedido a cor do olho escolhida vai aparecer ao lado do nome do PET.</small></div>
                    </div>

                    <!-- pet eye photo -->
                    <div v-if="pet_data.pet_photo">
                      <p>Acessórios:</p>
                      <div  class="pet-photos-list">
                        <div class="flex wrap">
                          <div v-for="(petAcessory, indexAcessory) in ['AURELA', 'OCULOS', 'LACO', 'GRAVATA']" :key="indexAcessory">
                            <div
                              v-if="petAcessory == 'AURELA'"
                              :class="{
                                active: pet_data.aurela == true,
                                'no-margin-left': indexAcessory == 0,
                              }"
                              class="item btn-photo"
                              @click="pet_data.aurela = !pet_data.aurela"
                            >
                                <img :src="decodeAurela(product.quantity_pets)"  style="max-width: 100px; min-height: 100px" />
                            </div>

                            <div
                              v-if="petAcessory == 'OCULOS' && pet_data.pet_type =='GATO'"
                              :class="{
                                active: pet_data.oculos == true,
                                'no-margin-left': indexAcessory == 0,
                              }"
                              class="item btn-photo"
                              @click="pet_data.oculos = !pet_data.oculos"
                            >
                                <img :src="decodeOculos(product.quantity_pets)" style="max-width: 100px; min-heigth: 100px">
                            </div>

                            <div
                              v-if="petAcessory == 'LACO'  && pet_data.pet_type =='GATO'"
                              :class="{
                                active: pet_data.laco == true,
                                'no-margin-left': indexAcessory == 0,
                              }"
                              class="item btn-photo"
                              @click="pet_data.laco = !pet_data.laco"
                            >
                                <img :src="decodeLaco(product.quantity_pets)"  style="max-width: 100px; min-height: 100px" />
                            </div>

                            <div
                              v-if="petAcessory == 'GRAVATA'  && pet_data.pet_type =='GATO'"
                              :class="{
                                active: pet_data.gravata == true,
                                'no-margin-left': indexAcessory == 0,
                              }"
                              class="item btn-photo"
                              @click="pet_data.gravata = !pet_data.gravata"
                            >
                                <img :src="decodeGravata(product.quantity_pets)"  style="max-width: 100px; min-height: 100px" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="item">
                    <a
                      :href="`#top-widget-${index}`"
                      style="text-decoration: none; color: #000;"
                    >
                      <div class="btn secondary">
                        Ver Tapete Personalizado
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-if="product.first_info">
              <h3>Frase Principal:</h3>
              <div>
                {{ product.first_info }}
              </div>
            </div>
            <div v-if="product.pet_name">
              <h3>Frase personalizada:</h3>
              <div>
                {{ product.pet_name }}
              </div>
            </div>
            <div class="">
              <h3>Tamanho: {{ product.size }}</h3>
              <h3>Cor: {{ product.color_bg }}</h3>
              <h3>Nome dos Pets:</h3>
              <div v-for="(pet, key) in product.pets_data" :key="key">
                {{ pet.pet_name }} {{ pet.pet_type == 'GATO' ? `(Olho ${pet.pet_eyer})` : '' }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!confirmationMode" class="action">
        <div v-if="!promocode && false">
          <div v-if="collection && collection.length < 2">
            <p style="text-align:center">
              <b>ATENÇÃO</b>: Ao comprar <b>2 únidades</b> ou mais você ganha
  
              <span style="font-size:18px"><b>10% de desconto</b></span
              >!!!
            </p>
            <p style="text-align:center">
              <small>*Oferta valida apenas para compras feitas HOJE.</small>
            </p>
          </div>
          <div v-else>
            <p style="text-align:center">
              Parabéns, você <b>ganhou 10 % de desconto</b>. Oferta valida apenas
              para compras feitas HOJE!
            </p>
          </div>
        </div>

        <div class="btn secondary" @click="addNewProduct()">
          + Adicionar mais um TAPETE
        </div>

        <!-- button -->
        <div @click="confirmationMode = true"
          style="text-decoration: none;color: #000;"
        >
        <div class="btn buy button-animate flex columns buy-link">
            COMPRAR AGORA!
            <small>(Clique Aqui)</small>
          </div>
        </div>

        <!-- order bump -->
        <div v-if="showOrderBump" class="orderbump flex columns">
          <!-- bolinha -->
          <div class="btn secondary margin-top-l" @click.stop="orderbump.ball = !orderbump.ball" :class="{ active: orderbump.ball}">
            <div style="color:#333">
              <img class="button-animate" src="@/assets/imgs/bolinha.png" style="max-width: 150px;">
              <p>Bolinha limpa DENTE!</p>
              <small>Adicione ração e seu pet vai se divertir e limpar os dentes ao mesmo tempo...</small>
            </div>
            <div v-if="!orderbump.ball">
              <p>+ Adicionar 1 Bolinha</p>
              <p>R$ 15,99</p>
            </div>
            <div v-else>
              <p>(X) Remover Bolinha</p>
            </div>
          </div>

          <!-- revisao -->
          <div class="btn secondary" @click.stop="orderbump.review = !orderbump.review" :class="{ active: orderbump.review}">
            <div style="color:#333">
              <img class="orderbump-animate" src="@/assets/imgs/revisao.png" style="max-width: 200px;">
              <p>Serviço de revisão dos textos personalizados!</p>
            </div>
            <div v-if="!orderbump.review">
              <p>+ Adicionar Revisão Ortográfica</p>
              <p>R$ 9,90</p>
            </div>
            <div v-else>
              <p>
                (X) Remover Revisão Ortográfica
              </p>
            </div>
          </div>
        </div>


        <!-- button -->
        <div 
          v-if="showOrderBump"
          @click="confirmationMode = true"
          style="text-decoration: none;color: #000;"
        >
          <div class="btn buy button-animate flex columns buy-link">
            COMPRAR AGORA!
            <small>(Clique Aqui)</small>
          </div>
        </div>

      </div>
      <div v-else-if="!confirmationModeReadOnly" class="flex center columns">
        <form @submit.prevent="buyProducts">
          <div style="max-width: 410px;">
            <div style="margin-top:20px">
              *<b>Observação</b>: 
              <p>Emoticons adicionados na frase ou nome do Pet serão removidos.</p>
              <p>Pode haver uma margem de erro entre 1-3cm devido a medição manual, e pode existir uma pequena diferença de cor de acordo com as imagens.</p>
            </div>
            <div style="margin-top:20px">
              *<b>Atenção</b>: Ao clicar em confirmar você está confirmando todos os dados da personalização. Vamos produzir o tapete exatamente com os dados informados. Caso tenha algo para alterar clique em <b>VOLTAR</b>.
            </div>
          </div>

          <div style="max-width: 410px; margin-top: 20px; width: 100%">
            <validation-provider
              vid="order-phone-confirmed"
              name="Telefone"
              rules="required|max:15|min:14"
              v-slot="{ errors }"
            >
              <div class="group-input" :class="{ errors: errors[0] }">
                Informe seu número de celular
                <div class="item">
                  <input
                    v-model="order_phone"
                    name="order_phone"
                    type="text"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    maxlength="15"
                    minlength="14"
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </div>
            </validation-provider>
          </div>

          <div style="max-width: 410px;">
            <div style="margin-top:20px flex center">
              <button class="btn primary w100" type="submit" style="font-size:22px">
                CONFIRMAR PEDIDO
              </button>
              <div class="btn secondary" @click="confirmationMode = false">
                VOLTAR
              </div>
            </div>
          </div>
        </form>
      </div>

      <div v-if="loader" id="background-loader">
        <div class="loader" id="loader"></div>
        <p>Carregando...</p>
      </div>
    </validation-observer>


  </section>
</template>

<script>
import { mask } from "vue-the-mask";

const mapping_price = {
  '60x40cm 1 false': "119,90",
  '60x40cm 2 false': "119,90",
  '60x40cm 3 false': "119,90",
  '60x40cm 4 false': "119,90",
  '60x40cm 5 false': "119,90",
  '60x40cm 6 false': "119,90",
  '60x40cm 7 false': "119,90",
  '60x40cm 8 false': "119,90",
  '50x80cm 1 false': "149,90",
  '50x80cm 2 false': "149,90",
  '50x80cm 3 false': "149,90",
  '50x80cm 4 false': "149,90",
  '50x80cm 5 false': "149,90",
  '50x80cm 6 false': "149,90",
  '50x80cm 7 false': "149,90",
  '50x80cm 8 false': "149,90",
  '60x40cm 1 true': "119,90",
  '60x40cm 2 true': "119,90",
  '60x40cm 3 true': "119,90",
  '60x40cm 4 true': "119,90",
  '60x40cm 5 true': "119,90",
  '60x40cm 6 true': "119,90",
  '60x40cm 7 true': "119,90",
  '60x40cm 8 true': "119,90",
  '50x80cm 1 true': "149,90",
  '50x80cm 2 true': "149,90",
  '50x80cm 3 true': "149,90",
  '50x80cm 4 true': "149,90",
  '50x80cm 5 true': "149,90",
  '50x80cm 6 true': "149,90",
  '50x80cm 7 true': "149,90",
  '50x80cm 8 true': "149,90",
};

const mapping_parcel_price = {
  '60x40cm 1 false': "11,27",
  '60x40cm 2 false': "11,27",
  '60x40cm 3 false': "11,27",
  '60x40cm 4 false': "11,27",
  '60x40cm 5 false': "11,27",
  '60x40cm 6 false': "11,27",
  '60x40cm 7 false': "11,27",
  '60x40cm 8 false': "11,27",
  '50x80cm 1 false': "12,26",
  '50x80cm 2 false': "12,26",
  '50x80cm 3 false': "12,26",
  '50x80cm 4 false': "12,26",
  '50x80cm 5 false': "12,26",
  '50x80cm 6 false': "12,26",
  '50x80cm 7 false': "12,26",
  '50x80cm 8 false': "12,26",
  '60x40cm 1 true': "11,27",
  '60x40cm 2 true': "11,27",
  '60x40cm 3 true': "11,27",
  '60x40cm 4 true': "11,27",
  '60x40cm 5 true': "11,27",
  '60x40cm 6 true': "11,27",
  '60x40cm 7 true': "11,27",
  '60x40cm 8 true': "11,27",
  '50x80cm 1 true': "12,26",
  '50x80cm 2 true': "12,26",
  '50x80cm 3 true': "12,26",
  '50x80cm 4 true': "12,26",
  '50x80cm 5 true': "12,26",
  '50x80cm 6 true': "12,26",
  '50x80cm 7 true': "12,26",
  '50x80cm 8 true': "12,26",
};

import BACKGROUND_1 from "@/assets/imgs/BACKGROUND/1.png";
import BACKGROUND_2 from "@/assets/imgs/BACKGROUND/2.png";
import BACKGROUND_3 from "@/assets/imgs/BACKGROUND/3.png";
import BACKGROUND_4 from "@/assets/imgs/BACKGROUND/4.png";
import BACKGROUND_5 from "@/assets/imgs/BACKGROUND/5.png";
import BACKGROUND_6 from "@/assets/imgs/BACKGROUND/6.png";

import BACKGROUND_1C from "@/assets/imgs/BACKGROUND/1C.png";
import BACKGROUND_2C from "@/assets/imgs/BACKGROUND/2C.png";
import BACKGROUND_3C from "@/assets/imgs/BACKGROUND/3C.png";
import BACKGROUND_4C from "@/assets/imgs/BACKGROUND/4C.png";
import BACKGROUND_5C from "@/assets/imgs/BACKGROUND/5C.png";
import BACKGROUND_6C from "@/assets/imgs/BACKGROUND/6C.png";

import BACKGROUND_CE2 from "@/assets/imgs/BACKGROUND/CE2.png";
import BACKGROUND_A2 from "@/assets/imgs/BACKGROUND/A2.png";
import BACKGROUND_B2 from "@/assets/imgs/BACKGROUND/B2.png";

import AURELA from "@/assets/imgs/ACESSORIOS/aurela.png";
import AURELA2 from "@/assets/imgs/ACESSORIOS/aurela2.png";
import OCULOS from "@/assets/imgs/ACESSORIOS/oculos.png";
import LACO from "@/assets/imgs/ACESSORIOS/laco.png";
import GRAVATA from "@/assets/imgs/ACESSORIOS/gravata.png";

const imagesBackground = {
  "1": BACKGROUND_1,
  "2": BACKGROUND_2,
  "3": BACKGROUND_3,
  "4": BACKGROUND_4,
  "5": BACKGROUND_5,
  "6": BACKGROUND_6,
  "7": BACKGROUND_6,
  "8": BACKGROUND_6,
  "1C": BACKGROUND_1C,
  "2C": BACKGROUND_2C,
  "3C": BACKGROUND_3C,
  "4C": BACKGROUND_4C,
  "5C": BACKGROUND_5C,
  "6C": BACKGROUND_6C,
  "7C": BACKGROUND_6C,
  "8C": BACKGROUND_6C,
  "CE2": BACKGROUND_CE2,
  "A2": BACKGROUND_A2,
  "B2": BACKGROUND_B2,
};

const imagesAurela = {
  '1': AURELA,
  '2': AURELA2,
  '3': AURELA2,
  '4': AURELA2,
  '5': AURELA2,
  '6': AURELA2,
  '7': AURELA2,
  '8': AURELA2,
}

const imagesOculos = {
  '1': OCULOS,
  '2': OCULOS,
  '3': OCULOS,
  '4': OCULOS,
  '5': OCULOS,
  '6': OCULOS,
  '7': OCULOS,
  '8': OCULOS,
}


const imagesLaco = {
  '1': LACO,
  '2': LACO,
  '3': LACO,
  '4': LACO,
  '5': LACO,
  '6': LACO,
  '7': LACO,
  '8': LACO,
}


const imagesGravata = {
  '1': GRAVATA,
  '2': GRAVATA,
  '3': GRAVATA,
  '4': GRAVATA,
  '5': GRAVATA,
  '6': GRAVATA,
  '7': GRAVATA,
  '8': GRAVATA,
}


const mapping_pet_photo = {
  'CACHORRO': {
    'A': ["01","02","03","04","05","10","11","12","13","14","1080","1081","1082","1083","1084","1085","1086"],
    'B': ["22", "23", "24", "25", "26", "27", "271", "272", "273", "273_1", "273_2", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "46_1", "47", "47_1", "48", "49", "60", "62", "63", "64", "64_1", "65", "66", "67", "68", "215", "216", "217", "1003", "1004", "1005", "1006", "1007", "1007_1", "1007_2", "1007_3", "1007_4", "1008", "1070", "1071", "1073", "1090", "1091", "1092", "1093", "1094", "1095", "1096", "1097", "2060", "2061", "2993", "2993_1", "2993_2", "2993_3", "2997"],
    'C': ["72", "73", "74", "75", "76", "88", "89", "90", "90_1", "91", "92", "93", "94", "95", "96", "97", "98", "99", "100", "101", "102", "103", "104", "105", "106", "107", "108", "113", "114", "118_1", "119", "119_1", "120_1", "120_2", "120_3", "228", "229", "230", "231", "285", "286", "287", "288", "289", "290", "291", "292", "293", "293_0", "293_1", "293_2", "293_3", "293_4", "1009", "1010", "1011", "1012", "1013", "1030", "1031", "1032", "1033", "1034", "1035", "1036", "1050", "1051", "1053", "1550", "1551", "1552", "2200", "2202", "2450", "2451", "2452", "2453", "2454", "2455", "2456", "2700", "2701", "2702", "2703", "2704"],
    'D-F': ["21_1","124","125","126","127","128","129","130","131","132_1","132_2","132","133","134","135","136","137","138","151","152_1","152","153","314","315","316","319","320_1","320_2","320_3","320","1390","1391","2650","2651","2950","2951","2952","2953","2954","2955"],
    'G-H': ["139_1","139_2","139_3","139","140","141","142","143","144","148","149","150_1","150","154","155","156","157","158","159","172","173","174","175","1880","1881","1882","1883"],
    'I-N': ["160","161_1","161","167","168","169","170","171","176","177","178","179","180","232","233_1","233","234","235","236","237","255","256","257","258","259","2100","2101","2102","2103","2104","2707","2708","2709","2710","2930","2930_1","2930_2","2930_3"],
    'O-R': ["08_1", "08_2", "08", "09", "15", "15_1", "16", "17", "18", "19", "20", "20_1", "21", "21_1", "80", "81", "82", "83", "84", "85", "86", "87", "145", "146", "147", "147_1", "147_2", "159_1", "159_2", "159_3", "162", "163", "164", "165", "166", "181", "182", "183", "184", "185", "186", "189_1", "189_2", "189", "190", "191", "192", "193", "194", "195", "196", "197_0", "197_1", "197_2", "197_3", "197", "199", "200", "201", "202_1", "202", "204", "205_1", "205", "206", "207", "208", "209", "210", "211", "212_1", "212", "213_1", "213", "214_1", "214", "218", "219", "220", "221", "222", "223", "238", "239", "240", "241", "243", "244", "247", "248", "250", "251", "252_01", "252_02", "252_0", "252_1", "252_2", "252_3", "252_4", "252_5", "252_6", "252_7", "252_8", "252_9", "252", "266", "267", "268", "269", "270_2", "270", "332", "333", "334", "1040_1", "1040", "1041", "1043", "2000", "2001", "2002", "2105", "2106", "2107", "2108", "2109", "2110", "2111", "2150", "2151", "2152", "2153", "2250", "2251", "2252", "2253", "2254", "2320", "2321", "2322", "2323", "2324", "2325", "2326", "2327", "2328", "2500", "2501", "2502", "2503", "2504", "2600", "2601", "2602", "2603", "2604", "2605", "2690", "2750", "2751", "2752", "2753", "2754", "2760", "2761", "2762", "2763", "2780", "2781", "2782", "2783", "2784", "2830", "2831", "2990", "2991", "2992"],
    'S-Y': ["57","58","59","197_1","197_2","197_3","233_1","255","256","257","258","259","274","275","276_1","276","278_1","278","279","280","281","282","283","284","293_5","293_6","294","295","296","297","298","299","300","301","302","303","304","305","306","307","308","309_1","309_2","309_3","309_4","309_5","309_6","309","310","324","325","326","327","335","336","337","340","341","342","1001","1200","1201","1350","1351","1352","2350","2351","2352","2400","2401","2800","2801","2802","2810","2811","2850","2851","2870","2871","2872","2873"],
  },
  'GATO': {
    'PELO-LONGO': ["386","387","388","389","390","391","392","393","394","395","396","397","398","399","400","401","402","403","404","405","406","407","408","409","410","411","412","413","414","415","416","417","418","419","420","421","422","423","424","425","426","427"],
    'PELO-CURTO': ["428","429","430","431","432","433","434","435","436","437","438","439","440","441","442","443","444","445","446","447","448","449","450","451","452","453","454","455","456","457","458","459","460","461","462","463","464","465","466","467","468","469","470","471","472","473","474","475","476","477"],
    'MALHADO': ["343","344","345","346","347","348","349","350","351","352","353","354","355","356","357","358","359","360","361","362","363","364","365","366","367","368","369"],
    'EGIPSIO': ["370","371","372","373","374","375","376","377","378","379","380","381","382","383","384","385"],
  },
  'COELHO': {
    'A-D': ["5002", "5000","5001","5003","5004","5005","5006","5007","5008","5009","5010","5011","5012","5013","5015","5016","5017","5018","5019","5020","5021","5022","5023","5024","5025","5026","5027","5028","5029"],
    'E-F': ["5030","5031","5032","5033","5034","5035","5036","5037","5038","5039","5040","5042","5043","5044","5045","5046","5047","5048","5049","5050","5051","5052","5053","5054","5055","5056","5057","5058","5059","5060","5061","5062"],
    'H-L': ["5063","5064","5065","5066","5067","5068","5069","5070","5071","5072","5073","5074","5075","5076","5077","5078","5079","5080","5081","5082","5083","5084","5085","5086","5087","5088","5089","5090","5091","5292"],
    'M-P': ["5092","5093","5094","5095","5096","5097","5098","5099","5100","5101","5102","5103","5104","5105","5106","5107","5108","5109","5110","5111","5112","5113","5114","5115","5116","5117","5118","5119","5120","5121","5122","5123","5124","5125","5126","5127","5128","5129","5130"],
  },
  'CRIANCA': {
    'TODAS': ["C2", "C3", "C4", "C5","C6", "C7", "C8", "C9", "C10", "C11", "C12", "C13", "C14", "C15", "C16", "C17", "C18", "C19", "C20", "C10_1","C10_2","C11_1","C11_2","C16_1","C16_2","C17_1","C18_1","C18_2","C21","C22","C23","C24","C25","C26","C27","C28_1","C28_2","C28","C29","C30","C31","C32","C33","C34","C35","C36","C37","C8_1","C9_1","C9_2"]
  },
  'ADULTO': {
    'TODOS': ["C38_1","C38","C39","C40","C41","C42","C43","C44","C45","C46","C47_1","C47","C48","C49","C50","C51","C52","C53","C54","C55","C56","C57","C58","C59","C60","C61","C62","C63","C64","C65","C66","C67","C68","C69","C70","C71"]
  }
}

const MAPPING_SIZE_TO_CODE = {
  '60x40cm 1': 'SC54SM5NW744', // 1-3 pets 4x60 149,90
  '60x40cm 2': 'SC54SM5NW744', // 1-3 pets 4x60 149,90
  '60x40cm 3': 'SC54SM5NW744', // 1-3 pets 4x60 149,90
  '60x40cm 4': 'SC54SM5NW744', // 4-6 pets 4x60 187,90
  '60x40cm 5': 'SC54SM5NW744', // 4-6 pets 4x60 187,90
  '60x40cm 6': 'SC54SM5NW744', // 4-6 pets 4x60 187,90
  '60x40cm 7': 'SC54SM5NW744', // 4-6 pets 4x60 187,90
  '60x40cm 8': 'SC54SM5NW744', // 4-6 pets 4x60 187,90
  '50x80cm 1': 'SS9165CYZ5CS', // 1-3 pets 50x80 214,90
  '50x80cm 2': 'SS9165CYZ5CS', // 1-3 pets 50x80 214,90
  '50x80cm 3': 'SS9165CYZ5CS', // 1-3 pets 50x80 214,90
  '50x80cm 4': 'SS9165CYZ5CS', // 3-6 pets 50x80 234,90
  '50x80cm 5': 'SS9165CYZ5CS', // 3-6 pets 50x80 234,90
  '50x80cm 6': 'SS9165CYZ5CS', // 3-6 pets 50x80 234,90
  '50x80cm 7': 'SS9165CYZ5CS', // 3-6 pets 50x80 234,90
  '50x80cm 8': 'SS9165CYZ5CS', // 3-6 pets 50x80 234,90
}

const MAPPING_KIT_QUANTITY = {
  '60x40cm 1 50x80cm 1': 'BT8YTEAH2CGG', // ok
  '60x40cm 1 50x80cm 2': 'D8CX1UQVW408', // ok
  '60x40cm 2 50x80cm 1': '88ROBOTM6W84', // ok
  '60x40cm 2 50x80cm 2': 'QWAXCRSELLW4', // ok
  '60x40cm 3 50x80cm 1': 'TTZIZGLDL5W4', // ok
  '60x40cm 3 50x80cm 2': 'B147N4WX6144', // ok
}

const MAPPING_DDDD_BIG_FRETE = {
  //SE: true
  '79': true,
  //MT: true,
  '65': true,
  '66': true,
  //PB: true,
  '71': true,
  '73': true,
  '74': true,
  '75': true,
  '77': true,
  //AL: true,
  '82': true,
  //PA: true,
  '83': true,
  //PE: true,
  '81': true,
  '87': true,
  //P,: true
  '86': true,
  '89': true,
  //GO: true,
  '62': true,
  '64': true,
}

const MAPPING_CODE_TO_CODE_BIG_FRETE = {
  // NORMAL KIT
  'SC54SM5NW744': '3BX8KBZZORS4',
  'SS9165CYZ5CS': 'BDCIE4N78U80',
  // KIT QUANTITY
  'BT8YTEAH2CGG': 'S40PAA12JIOC',
  'D8CX1UQVW408': 'CAADGU3X1UGC',
  '88ROBOTM6W84': 'S2MRF7BZZTC8',
  'QWAXCRSELLW4': '3STV2U56L3WG',
  'TTZIZGLDL5W4': 'HSEF32I4VA0C',
  'B147N4WX6144': '2BNVP2HVS9Z4',
}


// const FRASE_EXTRA = '74AF6H54AK'


// ORDER BUMP
const PRODUCT_REVIEW = '9FUVH1S4EW'
const PRODUCT_BALL = 'LWGMSRCJQW'


const DEFAULT_FIRST_INFO = 'BEM-VINDO'
const DEFAULT_SECOND_INFO = 'Não repare na bagunça, a culpa é do(a)'

const emptypet = {
  pet_type: 'GATO',
  pet_class: 'PELO-LONGO',
  pet_photo: '387',
  pet_name: '',
  pet_phone: null,
  pet_eyer: 'VERDE',
  aurela: false,
  oculos: false,
  laco: false,
  gravata: false,
}

const emptyProduct = {
  name: "",
  price: "119,90",
  has_subtitle: true,
  has_title: true,
  first_info: DEFAULT_FIRST_INFO,
  pet_name: DEFAULT_SECOND_INFO,
  pet_phone: '',
  price_parcel: "11,27",
  size: "60x40cm",
  color_bg: "Areia",
  quantity_pets: 1,
  pets_data: [emptypet]

};

export default {
  directives: { mask },
  name: "simulator",
  data() {
    return {
      loader: false,
      confirmationMode: false,
      confirmationModeReadOnly: false,
      showSubTitle: true,
      trackinCode: null,
      order_phone: '',
      collection: [this.$ObjectCopy(emptyProduct)],
      // sizes: ["20x30cm", "60x40cm", "50x80cm"],
      sizes: ["60x40cm", "50x80cm"],
      // sizes: ["60x40cm"],
      quantity_pets: [1, 2, 3, 4, 5, 6, 7, 8],
      accessories: ['aurela', 'oculos'],
      colors: ['Areia', 'Areia 2', 'Cinza', 'Cinza 2'],
      orderbump: {
        ball: false,
        review: false,
      },
      showModalSize: false,
      promocode: '',
    };
  },
  computed: {
    showOrderBump() {
      var aux = {}

      this.collection.forEach(c => {
        aux[c.size] = true
      })

      if (Object.keys(aux).length > 1) {
        return false
      }

      // FIXME: Deixar sempre desativado
      // yampi é muito ruim.

      return false
    }
  },
  mounted() {
    let preview = window.location.search || "";

    if (preview.includes('?preview=')) {
      preview = preview.replace('?preview=', '')
      preview = decodeURI(preview)
      preview = preview.split('%3A').join(':')
      try {
        this.collection = JSON.parse((preview));
      } catch (e) {
        console.error(e);
      }
    } else {
      try {
        let valueCookie = this.getCookie("cp-coleira-csa")
        if (valueCookie) {
          let axuData = JSON.parse(valueCookie)

          this.collection = []
          // FIXME: Ajustar para custom_product not is list

          
          axuData.forEach(p => {
            var custom_product = p.custom_product;
            
            var pets_data = []
            var quantity_pets = 0
            var color_bg = 'Areia'
            var first_info = ''
            var has_title = true
            var has_subtitle = true

            pets_data = custom_product.pets_data || custom_product.pets

  
            if (pets_data) {
              quantity_pets = pets_data.length
  
              color_bg = custom_product.color_bg
              first_info = custom_product.first_info
              has_title = custom_product.has_title
              has_subtitle = custom_product.has_subtitle
            }

            let product = {
              name: p.name,
              price: '',
              has_title: has_title,
              has_subtitle: has_subtitle,
              pet_name: p.pet_name,
              price_parcel: '',
              size: p.size,
              first_info: first_info,
              color_bg: color_bg,
              quantity_pets: quantity_pets,
              pets_data: pets_data
            }

            product.pets_data.forEach(pd => {
              pd.pet_eyer = 'VERDE' || pd.pet_eyer
            })

            if (product.size === undefined || product.quantity_pets === undefined || product.has_subtitle === undefined) {
              throw 'not accept format object'
            }

            let key = `${product.size} ${product.quantity_pets} ${product.has_subtitle}`

            product.price_parcel = mapping_parcel_price[key]
            product.price = mapping_price[key]


            let countPets = quantity_pets
            let keyCode = `${p.size} ${countPets}`;

            console.log('keyCode', keyCode)

            if (!Object.keys(MAPPING_SIZE_TO_CODE).includes(keyCode)) {
              return
            }

            this.collection.push(product)
          })
        }
      } catch (error) {
        console.log('error', error)
        // set init collection info
        this.collection = [this.$ObjectCopy(emptyProduct)]
      }
    }

    let confirmation_mode_csa = window.location.search || "";

    if (confirmation_mode_csa.includes('?confirmation_mode_csa')) {
      this.confirmationMode = true
      this.confirmationModeReadOnly = true
    }

    if (confirmation_mode_csa.includes('frase_simulator=')) {
      this.showSubTitle = true
    }


    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);
    this.promocode = params.get('promocode')
    if (this.promocode && this.promocode.includes('PBT')) {
      // set cookie promocode
      this.setCookie("promocode", this.promocode, 7);

      // tirhd cookie 
      // Making a GET request using the fetch API
      try {
        fetch(`https://pbt.bopoty.com/${this.promocode}`)
        fetch(`https://pbt.compresoagora.com/${this.promocode}`)
        fetch(`https://pbt.parceirosbopoty.com/${this.promocode}`)
      } catch (error) {
        console.log(error)
      }
    }

    if (!this.promocode) {
      let auxPromo = this.getCookie("promocode")

      if (auxPromo) {
        this.promocode = auxPromo
      }
    }


  },
  watch: {
    'collection': {
      handler() {
        this.collection.forEach(c => {
          c.pet_name = this.removeEmoji(c.pet_name)
          c.pets_data.forEach(p => {
            p.pet_name = this.removeEmoji(p.pet_name)
          })
        })

      },
      deep: true
    },
    'confirmationMode': {
      handler(value) {
        if (value) {
          this.collection.forEach(c => {
            c.pet_name = this.removeEmoji(c.pet_name)
            c.pets_data.forEach(p => {
              p.pet_name = this.removeEmoji(p.pet_name)
            })
          })
        }
      }
    }
  },
  methods: {
    openSizeModal() {
      this.showModalSize = !this.showModalSize
    },
    checkExistAcessory(listPet) {
      if (!listPet) {
        return false
      }

      var hasAcessory = false

      listPet.forEach(e => {
        if (e.aurela) {
          hasAcessory = true
          return
        }
      })

      return hasAcessory
    },
    onIOSEmojiPanelOpen(e) {
      e.preventDefault();
    },
    ignoreSystemEmojis(e) {
      console.log('e', e)
      // e.preventDefault();
      // if (!/^[a-zA-Z\s&\d]*$/.test(e.key)) {
      //   e.preventDefault();
      // }
    },
    removeEmoji(value) {
      if (!value) {
        return ''
      }

      // var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
      // return value.replace(regex, '');

      return value
    },
    sendConfirmation(custom_info) {
        if (!custom_info) {
            // not send request in case not exist values =/
            this.loader = false
            return
        }
        custom_info = encodeURIComponent(custom_info)

        let cleanPhone = this.order_phone

        // send data to backend
        let params = `phone_order=${cleanPhone}&custom_info=${custom_info}`

        fetch(`https://api.compresoagora.com/confirmation?${params}`)
          .then((response) => {
            console.log(response)
            this.formatUrlToYampi()
          })
          .catch((e) => {
            console.log(e)
            this.loader = false
            alert("Ocorreu algum problema, tente novamente!")
          })
    },
    addPersonalizationFrase(product) {
      if (product.has_subtitle) {
        product.has_subtitle = false
        product.pet_name = ''

        let key = `${product.size} ${product.quantity_pets} ${product.has_subtitle}`
        product.price = mapping_price[key];
        product.price_parcel = mapping_parcel_price[key];

        return
      }

      product.has_subtitle = true
      product.pet_name = DEFAULT_SECOND_INFO

      let key = `${product.size} ${product.quantity_pets} ${product.has_subtitle}`
      product.price = mapping_price[key];
      product.price_parcel = mapping_parcel_price[key];

    },
    addTitle(product) {
      if (product.has_title) {
        product.has_title = false
        product.first_info = ''

        return
      }

      product.has_title = true
      product.first_info = DEFAULT_FIRST_INFO

    },
    addNewProduct() {
      this.collection.push(this.$ObjectCopy(emptyProduct));
    },
    deleteProduct(index) {
      if (window.confirm("Você realmente quer remover o produto?")) {
        this.collection.splice(index, 1);
      }
    },
    changeColorProduct(index, colorType) {
      this.collection[index].color_bg = colorType;
    }, 
    changePetType(pet_data, petType) {
      pet_data.pet_type = petType
      pet_data.pet_class = Object.keys(mapping_pet_photo[petType])[0]
      // change class pet to change pet photo
      this.changePetClass(pet_data, pet_data.pet_class)
    },
    changePetClass(pet_data, petClass) {
      pet_data.pet_class = petClass
      if (petClass == 'TODOS') {
        let aux_class= Object.keys(mapping_pet_photo[pet_data.pet_type])[0]
        pet_data.pet_photo = `${aux_class}/${mapping_pet_photo[pet_data.pet_type][aux_class][0]}`
      } else {
        pet_data.pet_photo = mapping_pet_photo[pet_data.pet_type][pet_data.pet_class][0]
      }

      pet_data.aurela = false
      pet_data.oculos = false
    },
    buyProducts() {
      // save cookie product :)
      this.$refs.form.validate().then((success) => {
        if (!success) {
          alert("Você precisa preencher o número de celular para confirmar o pedido.");
          return;
        }

        this.loader = true

        let saveInfoProducts = [];

        this.collection.forEach((p) => {
          // format names
          p.pets_data.forEach(a => {
            a.pet_name = a.pet_name.toLowerCase()
            a.pet_name = a.pet_name.charAt(0).toUpperCase() + a.pet_name.slice(1);
          })

          saveInfoProducts.push({
            color: p.color_bg,
            size: p.size,
            has_subtitle: p.has_subtitle,
            pet_name: p.pet_name,
            pet_phone: this.order_phone,
            custom_product: {
              has_title: p.has_title,
              has_subtitle: p.has_subtitle,
              first_info: p.first_info,
              second_info: p.pet_name,
              color_bg: p.color_bg,
              pets: p.pets_data
            },
          });
        });

        console.log(JSON.stringify(saveInfoProducts))

        this.setCookie("cp-coleira-csa", JSON.stringify(saveInfoProducts), 30);


        this.sendConfirmation(JSON.stringify(saveInfoProducts))

      });
    },
    formatUrlToYampi() {
        this.loader = true;
        // generate url
        let productsCode = [];

        // parsing collection to calculate quantity

        let aux_collection = {};

        let aux_count_size = {
          '60x40cm': 0,
          '50x80cm': 0,
        }

        let DDD = this.order_phone && this.order_phone.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
        DDD = DDD.slice(0, 2)

        this.collection.forEach((p) => {

          let countPets = p.pets_data.length

          let key = `${p.size} ${countPets}`;
          
          // count sizes
          aux_count_size[p.size] += 1

          let productCode = MAPPING_SIZE_TO_CODE[key]
          // exist object
          if (Object.keys(aux_collection).includes(productCode)) {
            aux_collection[productCode].quantity += 1;
          } else {
            aux_collection[productCode] = {
              productCode: productCode,
              quantity: 1,
            };
          }

          //check has subtitle product
          // if (p.has_subtitle) {
          //   if (Object.keys(aux_collection).includes(FRASE_EXTRA)) {
          //     aux_collection[FRASE_EXTRA].quantity += 1;
          //   } else {
          //     aux_collection[FRASE_EXTRA] = {
          //       productCode: FRASE_EXTRA,
          //       quantity: 1,
          //     };
          //   }
          // }
        });

        // create url
        Object.keys(aux_collection).forEach((p) => {
          // get code checkout
          let productCode = aux_collection[p].productCode;
          let quantity = aux_collection[p].quantity;

          // check ddd is big frete
          if (MAPPING_DDDD_BIG_FRETE[DDD]) {
            // TODO: ALTERAR CODE to big frete in case DDD
            let newTokenBigFrete = MAPPING_CODE_TO_CODE_BIG_FRETE[productCode]
            if (newTokenBigFrete) {
              productCode = newTokenBigFrete
            }

          }

          productsCode.push(`${productCode}:${quantity}`);
        });

        // get first produt ;O
        // FIXME: Necessiario pois a merd@ da yampi não suporta multi KIT no link compra...
        // suporta só para produto.
        // productsCode = productsCode.filter(e => ![PRODUCT_BALL, PRODUCT_REVIEW].includes(e.split(':')[0]))

        let token = productsCode[0];

        // check have orderbump
        if (this.orderbump.review) {
          token = `${token};`
          aux_collection[PRODUCT_REVIEW] = {
              productCode: PRODUCT_REVIEW,
              quantity: 1,
            };
        
        }
        if (this.orderbump.ball) {
          aux_collection[PRODUCT_BALL] = {
              productCode: PRODUCT_BALL,
              quantity: 1,
            };
        }

        console.log('productsCode', productsCode)

        if (productsCode.length > 1) {

          let _subKey = `60x40cm ${aux_count_size['60x40cm']} 50x80cm ${aux_count_size['50x80cm']}`
          let newToken = MAPPING_KIT_QUANTITY[_subKey];

          if (!newToken) {
            alert("Ocorreu um problema. Fale com nosso suporte via whatsapp em: (41) 99107-4849")
          }


          // check ddd is big frete
          if (MAPPING_DDDD_BIG_FRETE[DDD]) {
            // TODO: ALTERAR CODE to big frete in case DDD

            let newTokenBigFrete = MAPPING_CODE_TO_CODE_BIG_FRETE[newToken]
            if (newTokenBigFrete) {
              newToken = newTokenBigFrete
            }

          }


          token = `${newToken}:1`
        }


        let url = `https://seguro.bopoty.com/b/${token}`;

        let cleanPhone = this.order_phone && this.order_phone.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
        // check exist UTM in link
        const search = window.location.search || "";
        if (search) {

          // remove utm_term and add phone confirmation
          let splitSearch = search.replace('?','').split('&')

          let newSearchList = []
          splitSearch.forEach((e) => {
            if (!e.includes('utm_term=')) {
              newSearchList.push(e)
            }
          })

          let newSearch = newSearchList.join('&')

          url += "?"+newSearch;
        }

        if (this.promocode) {
          // have promocode
          if (url && url.includes('?')) {
              url += `&promocode=${this.promocode}`;
          } else {
              url += `?promocode=${this.promocode}`;
          }

        } else {
          // 10% off in buy 2 products and not promocode
          // if (this.collection && this.collection.length > 1) {
          //   if (url && url.includes('?')) {
          //     url += "&promocode=10%OFFTAPETE";
          //   } else {
          //     url += `?promocode=10%OFFTAPETE`;
          //   }
          // }
        }


        if (url && url.includes('?')) {
          url += `&utm_term=${cleanPhone}`;
        } else {
          url += `?utm_term=${cleanPhone}`;
        }

        // redirect
        window.top.location.href = url;

        this.loader = false;
    },
    decodeBackground(prod) {
      let number = prod.quantity_pets;
      var color = '';
      if (prod.color_bg === 'Cinza') {
        color = 'C'
      }

      if (prod.color_bg === 'Cinza 2') {
        color = 'CE2'
        return imagesBackground[color]
      }

      if (prod.color_bg === 'Branco') {
        color = 'B2'
        return imagesBackground[color]
      }

      if (prod.color_bg === 'Areia 2') {
        color = 'A2'
        return imagesBackground[color]

      }


      return imagesBackground[number+color]
    },
    decodeAurela(number) {
      return imagesAurela[number]
    },
    decodeOculos(number) {
      return imagesOculos[number]
    },
    decodeLaco(number) {
      return imagesLaco[number]
    },
    decodeGravata(number) {
      return imagesGravata[number]
    },
    decodePetPhotos(my_type, my_class) {
      if (my_class == 'TODOS') {
        let values = []
        Object.keys(mapping_pet_photo[my_type]).forEach(k => {
          mapping_pet_photo[my_type][k].forEach(v => {
            values.push(`${k}/${v}`)
          })
        })

        return values
      }
      return mapping_pet_photo[my_type][my_class]
    },
    decodePhotoUrl(product, petPhoto) {
      if (product.pet_class == 'TODOS') {
        return `https://oferta.compresoagora.com/simulador-tapete-full/imgs/${product.pet_type}/${petPhoto}.png`
      }
      return `https://oferta.compresoagora.com/simulador-tapete-full/imgs/${product.pet_type}/${product.pet_class}/${petPhoto}.png`
    },
    changeSizeProduct(index, size) {

      if (size == '20x30cm') {
        alert('O tamanho 20x30cm no valor de R$ 119,90 está esgotado.')
        return
      }

      this.collection[index].size = size;

      let key = `${size} ${this.collection[index].quantity_pets} ${this.collection[index].has_subtitle}`

      this.collection[index].price = mapping_price[key];
      this.collection[index].price_parcel = mapping_parcel_price[key];
    },

    changeQuantityPet(index, qt) {
      this.collection[index].quantity_pets = qt;

      let key = `${this.collection[index].size} ${qt} ${this.collection[index].has_subtitle}`

      this.collection[index].price = mapping_price[key];
      this.collection[index].price_parcel = mapping_parcel_price[key];

      let pets_data = this.collection[index].pets_data

      let qt_number = parseInt(qt)

      if (pets_data.length >= qt_number) {
        this.collection[index].pets_data.splice(qt_number, pets_data.length - qt_number)
      } else {
        while (pets_data.length < qt_number) {
          pets_data.push(this.$ObjectCopy(emptypet))

        }
        this.collection[index].pets_data = this.$ObjectCopy(pets_data)
      }
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "; expires=" + date.toGMTString();
      document.cookie =
        name + "=" + value + expires + "; path=/;";
      // document.cookie = name + "=" + value + expires + "; path=/";
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: #ffffff;
}

.w100 {
  width: 100%;
}

.max-width {
  max-width: 400px !important;
}
.flex {
  display: flex !important;
}

.flex-1 {
  flex: 1
}
.wrap {
  flex-flow: wrap;
}
h2 {
  margin-top: 5px;
  margin-bottom: 5px;
}
.center {
  align-items: center;
  align-content: center;
  justify-content: center;
}
.columns {
  flex-direction: column;
}
.rows {
  flex-direction: row;
}
.item {
  flex: 1;
}
.photo > img {
  width: 100%;
  // height: 700px;
}
.delete-btn {
  width: 10px;
  padding: 20px;
  position: absolute;
  z-index: 999;
  right: 20px;
}
.btn {
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 5px;
  background-color: #e6e5e5;
  border-bottom: 3px solid rgb(0, 0, 0);
  font-weight: 700;
  cursor: pointer;
}

.w-color {
  padding: 25px;
  border-radius: 5px;
  background-color: #c2c2c2;
  margin-left: 10px;
  border-bottom: 3px solid rgb(0, 0, 0);
  border-left: 1px solid rgb(0, 0, 0);
  font-weight: 700;
  cursor: pointer;
  &.active {
    border-bottom: 0px solid #333;
    border-left: 0px solid #333;
    filter: grayscale(30%);
  }
}
.primary {
  margin-top: 15px;
  padding-top: 25px;
  padding-bottom: 25px;
  color: #fff;
  background: #0ab26e;
  border: 3px solid #0ab26e;
  text-align: center;
  box-shadow: 2px 3px 2px #8a8a8a;
  &:hover {
    background: #0ab26e;
    color: #fff;
  }
}

.secondary {
  margin-top: 15px;
  padding-top: 25px;
  padding-bottom: 25px;
  color: #0ab26e;
  background: #fff;
  border: 3px solid #0ab26e;
  text-align: center;
  box-shadow: 2px 3px 2px #8a8a8a;
  &:hover {
    background: #0ab26e;
    color: #fff;
  }
}

.w-size {
  padding: 15px;
  border-radius: 5px;
  background-color: #c2c2c2;
  margin-left: 10px;
  border-bottom: 3px solid rgb(0, 0, 0);
  border-left: 1px solid rgb(0, 0, 0);
  font-weight: 700;
  cursor: pointer;

  &.active {
    /* border: 1px solid #333; */
    border-bottom: 0px solid #333;
    border-left: 0px solid #333;
    background-color: #0ab26e;
  }
}

.buy {
  margin-top: 15px;
  margin-left: 0px;
  background-color: #c3c3c3;
  color: #fff;
  background-color: #0ab26e;
  text-align: center;
  font-size: 18px;
  font-weight: 800;
  padding-top: 25px;
  padding-bottom: 25px;
  border-radius: 5px;
  width: 100%;
}

hr {
  height: 0px;
  width: 100%;
  border-bottom: 1px solid rgba(51, 51, 51, 0.996);
}

.item input {
  width: 97%;
  height: 40px;
  font-size: 21px;
  padding-left: 10px;
  border-radius: 5px;
}
.simulator {
  position: relative;
  max-width: 480px;
}

.name-simulator {
  color: #000;
  font-size: 13px;
  font-weight: 700;
  min-height: 55px;
  font-family: AdelicaBrush, Muli;
  text-transform: capitalize;
  font-style: normal;
  width: 100%;
  text-align: center;
}

.simulator-name {
  position: absolute;
  // padding-left: 8px;
  padding-left: 4px;
  text-align: center;
  width: 100%;
  top: 26%;
  font-size: 36px;
  font-weight: 800;
  font-family: 'Spicy Rice', sans-serif;
}
.simulator-subname {
  position: absolute;
  padding-left: 8px;
  text-align: center;
  width: 100%;
  top: 36%;
  font-size: 13px;
  font-weight: 800;
}
.simulator-position {
  position: absolute;
  text-align: center;
  z-index: 10;
  width: 100%;
  height: 100%;
  padding-top: 50%;
}

.list-pets {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
}

.pet-photos-list {
  max-height: 400px;
  overflow-y: auto;
  margin-right: 40px;
  padding: 8px;
  border: 1px solid #c2c2c2;
  border-radius: 10px;

  .active {
    border: 1px solid #0ab26e;
    box-shadow: 2px 2px #0ab26e;
  }
}

.aurela-pet {
  position: absolute;
  // top: -22px;
  top: -35px;
  left: -49px;
  z-index: 1;
  img {
    width: 200px;
  }
}

.oculos-pet {
  position: absolute;
  // top: 16px;
  top: 3px;
  left: -24px;
  z-index: 12;
  width: 100px;
  img {
    width: 150px;
  }

}



.laco-pet {
  position: absolute;
  top: 36px;
  // top: 3px;
  left: 0px;
  z-index: 12;
  width: 100px;
  img {
    width: 100px;
  }
}

.gravata-pet {
  position: absolute;
  top: 36px;
  // top: 3px;
  left: 0px;
  z-index: 12;
  width: 100px;
  img {
    width: 100px;
  }
}



.pet_1 {
  .simulator-pet-0 {
    position: absolute;
    left: 38%;
    // top: 28%;
    top: 32%;
  }
}

.pet_2 {
  .simulator-pet-0 {
    position: absolute;
    left: 21%;
    // top: 28%;
    top: 32%;
  }
  .simulator-pet-1 {
    position: absolute;
    left: 58%;
    // top: 28%;
    top: 32%;
  }
}

.pet_3 {
  .simulator-pet-0 {
    position: absolute;
    left: 13%;
    // top: 28%;
    top: 32%;
  }
  .simulator-pet-1 {
    position: absolute;
    left: 38%;
    // top: 28%;
    top: 32%;
  }
  .simulator-pet-2 {
    position: absolute;
    left: 64%;
    // top: 28%;
    top: 32%;
  }
}

.pet_4 {
  
  .simulator-pet-0 {
    position: absolute;
    left: 10%;
    // top: 28%;
    top: 32%;
  }
  .simulator-pet-1 {
    position: absolute;
    left: 29%;
    // top: 28%;
    top: 32%;
  }
  .simulator-pet-2 {
    position: absolute;
    left: 47%;
    // top: 28%;
    top: 32%;
  }
  .simulator-pet-3 {
    position: absolute;
    left: 65%;
    // top: 28%;
    top: 32%;
  }
}

.pet_5 {
  .aurela-pet {
    top: -36px;
    left: -24px;
    img {
      width: 130px;
    }
  }

  .laco-pet {
    top: 16px;
    left: 1px;
    width: 80px;
    img {
      width: 80px;
    }
  }

  .gravata-pet {
    top: 16px;
    left: 1px;
    width: 80px;
    img {
      width: 80px;
    }
  }


  .oculos-pet {
        top: -14px;
    left: -18px;
    img {
      width: 120px;
    }

  }
  .simulator-subname {
    top: 39% !important;
  }

  .name-simulator {
    position: absolute;
    bottom: -19px;
    color: #fff;
    font-size: 12px;
  }
  .photo-simulator img {
    width: 82px;
  }
  .simulator-pet-0 {
    position: absolute;
    left: 14%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-1 {
    position: absolute;
    left: 30%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-2 {
    position: absolute;
    left: 47%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-3 {
    position: absolute;
    left: 64%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-4 {
    position: absolute;
    left: 38%;
    top: 29%;
    z-index: 8;

    .name-simulator {
      top: -10px;
      color: #000;
    }
  }
}

.pet_6 {
    .aurela-pet {
    top: -36px;
    left: -24px;
    img {
      width: 130px;
    }
  }

  .laco-pet {
    top: 16px;
    left: 1px;
    width: 80px;
    img {
      width: 80px;
    }
  }

  .gravata-pet {
    top: 16px;
    left: 1px;
    z-index: 12;
    width: 80px;
    img {
      width: 90px;
    }
  }


  .oculos-pet {
    top: -14px;
    left: -18px;
    img {
      width: 120px;
    }

  }

  .photo-simulator img {
    width: 82px;
  }
  .name-simulator {
    position: absolute;
    bottom: -19px;
    color: #fff;
    font-size: 12px;
  }

  .simulator-subname{
    top: 39% !important;
  }

  .simulator-pet-0 {
    position: absolute;
    left: 14%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-1 {
    position: absolute;
    left: 30%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-2 {
    position: absolute;
    left: 47%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-3 {
    position: absolute;
    left: 64%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-4 {
    position: absolute;
    left: 28%;
    top: 29%;
    z-index: 8;
    .name-simulator {
      top: -10px;
      color: #000;
    }
  }
  .simulator-pet-5 {
    position: absolute;
    left: 50%;
    top: 29%;
    z-index: 8;
    .name-simulator {
      top: -10px;
      color: #000;
    }
  }
}


.pet_7 {
    .aurela-pet {
    top: -36px;
    left: -24px;
    img {
      width: 130px;
    }
  }

  .laco-pet {
    top: 16px;
    left: 1px;
    width: 80px;
    img {
      width: 80px;
    }
  }

  .gravata-pet {
    top: 16px;
    left: 1px;
    width: 80px;
    img {
      width: 80px;
    }
  }


  .oculos-pet {
    top: -14px;
    left: -18px;
    img {
      width: 120px;
    }

  }

  .photo-simulator img {
    width: 82px;
  }
  .name-simulator {
    position: absolute;
    bottom: -19px;
    color: #fff;
    font-size: 12px;
  }

  .simulator-subname{
    top: 39% !important;
  }

  .simulator-pet-0 {
    position: absolute;
    left: 14%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-1 {
    position: absolute;
    left: 30%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-2 {
    position: absolute;
    left: 47%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-3 {
    position: absolute;
    left: 64%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-4 {
    position: absolute;
    left: 24%;
    top: 29%;
    z-index: 8;
    .name-simulator {
      top: -10px;
      color: #000;
    }
  }
  .simulator-pet-5 {
    position: absolute;
    left: 39%;
    top: 29%;
    z-index: 8;
    .name-simulator {
      top: -10px;
      color: #000;
    }
  }
  .simulator-pet-6 {
    position: absolute;
    left: 54%;
    top: 29%;
    z-index: 8;
    .name-simulator {
      top: -10px;
      color: #000;
    }
  }
}

.pet_8 {
    .aurela-pet {
    top: -36px;
    left: -24px;
    img {
      width: 130px;
    }
  }

  .oculos-pet {
    top: -14px;
    left: -18px;
    img {
      width: 120px;
    }

  }

  .laco-pet {
    top: 16px;
    left: 1px;
    width: 80px;
    img {
      width: 80px;
    }
  }

  .gravata-pet {
    top: 16px;
    left: 1px;
    width: 80px;
    img {
      width: 80px;
    }
  }


  .photo-simulator img {
    width: 82px;
  }

  
  .name-simulator {
    position: absolute;
    bottom: -19px;
    color: #fff;
    font-size: 12px;
  }

  .simulator-subname{
    top: 39% !important;
  }

  .simulator-pet-0 {
    position: absolute;
    left: 14%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-1 {
    position: absolute;
    left: 30%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-2 {
    position: absolute;
    left: 47%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-3 {
    position: absolute;
    left: 64%;
    top: 36%;
    z-index:9;
  }
  .simulator-pet-4 {
    position: absolute;
    left: 15%;
    top: 29%;
    z-index: 8;
    .name-simulator {
      top: -10px;
      color: #000;
    }
  }
  .simulator-pet-5 {
    position: absolute;
    left: 30%;
    top: 29%;
    z-index: 8;
    .name-simulator {
      top: -10px;
      color: #000;
    }
  }
  .simulator-pet-6 {
    position: absolute;
    left: 46%;
    top: 29%;
    z-index: 8;
    .name-simulator {
      top: -10px;
      color: #000;
    }
  }
  .simulator-pet-7 {
    position: absolute;
    left: 62%;
    top: 29%;
    z-index: 8;
    .name-simulator {
      top: -10px;
      color: #000;
    }
  }
}

.clean_bg {
    .name-simulator {
      color: #000 !important;
    }
  }

.box-eyer {
  width: 100px;
  height: 100px;
  border-radius: 10px;
}

.eyergreen {
    background: #008000ad;
}

.eyerblue {
    background: #00f9;
}

.eyeryellow {
    background: #ffff0082;
}


.top-widget {
  max-width: 400px;
  margin: 0 auto;
  margin-bottom: 35px;
  position:relative;
}

@keyframes zoominoutsinglefeatured {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
.button-animate {
  animation: zoominoutsinglefeatured 1s infinite;
}

@keyframes zoominoutsinglefeatured4 {
  0% {
    transform: rotate(-0deg);
  }
  35% {
    transform: rotate(-1.5deg);
  }
  65% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1.5deg);
  }
}

.orderbump-animate {
  animation: zoominoutsinglefeatured4 1s infinite;
}

@keyframes zoominoutsinglefeatured2 {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.03, 1.03);
  }
  100% {
    transform: scale(1, 1);
  }
}
.banner-animate {
  animation: zoominoutsinglefeatured2 1s infinite;
}

@keyframes zoominoutsinglefeatured3 {
  0% {
    transform: rotate(0deg);
  }
  35% {
    transform: rotate(-3deg);
  }
  65% {
    transform: rotate(3deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
.dance-pet {
  animation: zoominoutsinglefeatured3 1s infinite;
}

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

.current-price {
  color: #000;
  font-size: 32px;
  font-weight: 800;
  text-shadow: 1px 1px #f5f7f4a6;
  background: #14ff00;
  padding: 15px;
  border-radius: 10px;
}

#background-loader {
  position: fixed;
  display: flex !important;
  flex-direction: column;
  color: #fff;
  font-weight: 700;
  align-content: center;
  align-items: center;
  align-self: center;
  justify-content: center;
  z-index: 1000;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.hide-loader {
  display: none;
}

.group-input {
  &.errors input {
    border: 1px solid red;
    border-radius: 4px;
  }
  .erros-alert {
    display: inline-block;
    color: red;
    font-size: 11px;
  }
}

.nojuros {
  font-weight: 700;
  color: #0ab26e;
}

.btn-photo {
  padding: 2px;
  border: 1px solid #c2c2c2;
  border-radius: 10px;
  margin-right: 5px;
  margin-top: 5px;
  min-width: 100px;
  min-height: 100px;
  cursor: pointer;
}

.photo-simulator img {
  width: 100px;
  // margin-top:15px;

}

.photo-simulator {
  position: relative;
  z-index: 11;
}

// com acessorio DE AURELA
// precisa subir o nome dos PETS
.hasAcessory {
  .photo-simulator img {
    margin-top:15px;
  }
  .aurela-pet {
    top: -22px;
  }

  .oculos-pet {
    top: 16px;

  }

  .pet_1 {
    .simulator-pet-0 {
      top: 28% !important;
    }
  }

  .pet_2 {
    .simulator-pet-0 {
      top: 28%;
    }
    .simulator-pet-1 {
      top: 28%;
    }
  }

  .pet_3 {
    .simulator-pet-0 {
      top: 28%;
    }
    .simulator-pet-1 {
      top: 28%;
    }
    .simulator-pet-2 {
      top: 28%;
    }
  }

  .pet_4 {
    
    .simulator-pet-0 {
      top: 28%;
    }
    .simulator-pet-1 {
      top: 28%;
    }
    .simulator-pet-2 {
      top: 28%;
    }
    .simulator-pet-3 {
      top: 28%;
    }
  }

  .pet_quantity_5 {
    .simulator-name {
      top: 24% !important;
    }
    .simulator-subname {
      top: 34% !important;
    }
  }
  .pet_5 {
    

    .aurela-pet {
      top: -19px;
    }

    .oculos-pet {
      top: 0px;

    }
    .simulator-pet-0 {
      top: 33%;
    }
    .simulator-pet-1 {
      top: 33%;
    }
    .simulator-pet-2 {
      top: 33%;
    }
    .simulator-pet-3 {
      top: 33%;
    }
    .simulator-pet-4 {
      top: 26%;
      .name-simulator {
        top: -6px;
      }
    }
  }
  .pet_6 {
    .aurela-pet {
      top: -19px;
    }

    .oculos-pet {
      top: 0px;

    }
    .simulator-pet-0 {
      top: 33%;
    }
    .simulator-pet-1 {
      top: 33%;
    }
    .simulator-pet-2 {
      top: 33%;
    }
    .simulator-pet-3 {
      top: 33%;
    }
    .simulator-pet-4 {
      top: 26%;
      .name-simulator {
        top: -6px;
      }
    }
    .simulator-pet-5 {
      top: 26%;
      .name-simulator {
        top: -6px;
      }
    }
  }
  .pet_7 {
    .aurela-pet {
      top: -19px;
    }

    .oculos-pet {
      top: 0px;

    }
    .simulator-pet-0 {
      top: 33%;
    }
    .simulator-pet-1 {
      top: 33%;
    }
    .simulator-pet-2 {
      top: 33%;
    }
    .simulator-pet-3 {
      top: 33%;
    }
    .simulator-pet-4 {
      top: 26%;
      .name-simulator {
        top: -6px;
      }
    }
    .simulator-pet-5 {
      top: 26%;
      .name-simulator {
        top: -6px;
      }
    }
    .simulator-pet-6 {
      top: 26%;
      .name-simulator {
        top: -6px;
      }
    }
  }
  .pet_8 {
    .aurela-pet {
      top: -19px;
    }

    .oculos-pet {
      top: 0px;

    }
    .simulator-pet-0 {
      top: 33%;
    }
    .simulator-pet-1 {
      top: 33%;
    }
    .simulator-pet-2 {
      top: 33%;
    }
    .simulator-pet-3 {
      top: 33%;
    }
    .simulator-pet-4 {
      top: 26%;
      .name-simulator {
        top: -6px;
      }
    }
    .simulator-pet-5 {
      top: 26%;
      .name-simulator {
        top: -6px;
      }
    }
    .simulator-pet-6 {
      top: 26%;
      .name-simulator {
        top: -6px;
      }
    }
    .simulator-pet-7 {
      top: 26%;
      .name-simulator {
        top: -6px;
      }
    }
  }

  &.pet_quantity_5 {
    .simulator-name {
      top: 23%;
    }
    .simulator-subname {
      top: 33%;
    }
  } 
  &.pet_quantity_6 {
    .simulator-name {
      top: 23%;
    }
    .simulator-subname {
      top: 33%;
    }
  } 
  &.pet_quantity_7 {
    .simulator-name {
      top: 23%;
    }
    .simulator-subname {
      top: 33%;
    }
  } 
  &.pet_quantity_8 {
    .simulator-name {
      top: 23%;
    }
    .simulator-subname {
      top: 33%;
    }
  }
}

@media screen and (max-width: 1280px) {
  h2 {
    font-size: 18px;
  }
  .rows {
    flex-direction: column;
  }
  .photo > img {
    width: 100%;
    height: auto;
  }
  .item input {
    width: 95%;
  }
  .w-color {
    margin-left: 5px;
  }
  .w-size {
    margin-left: 5px;
  }
  .name-simulator {
    color: #000;
    font-size: 13px;
    font-weight: 800;
    min-height: 22px;
    font-family: AdelicaBrush, Muli;
    text-transform: capitalize;
    font-style: normal;
    width: 100%;
    text-align: center;
  }

  .add {
    margin-top: 15px;
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .btn {
    padding: 35px;
    margin-top: 5px;
    text-align: center;
  }
  .delete-btn {
    position: absolute;
    z-index: 999;
    width: auto;
    font-size: 20px;
    padding: 20px;
    position: absolute;
    right: 10px !important;
  }

  .secondary {
    margin-top: 15px;
  }
  .buy {
    width: 100%;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 35px;
    padding-bottom: 35px;
    margin-left: 0px;
    margin-top: 30px;
    text-align: center;
  }

  .simulator-position {

    &.onlyName {
      top: -16px;
      left: -46px;
      .name-simulator {
        font-size: 19px !important;
      }
    }
  }
}

.promo-banner {
  position: absolute;
  bottom: -20px;
  left: 0px;
  img {
    max-width: 160px;
  }

  &.promo-confirmation {
  }
  
  z-index: 999;
}

.disabled{
  background-color: #c2c2c268;
  color: #919191;
  border-bottom: none;
  border-left: none;
  font-size: 14px;
  padding:29px;


}

.diff-size {
  margin-top: 12px;
  margin-left: 12px;
}

.modal-size {
  // position: fixed;
  position: relative;
  left: 0px;
  top: 0px;
  z-index: 99999;
  width: 100%;
  height: 100%;
  // background: rgba(0,0,0,0.4);
  // 
  .box {
    .box-content {
      background: #fff;
      padding: 15px;
      border-radius: 7px;
      img {
        max-width: 350px;
        border-radius: 7px;
      }
    }
  }
}

.clean_bg {
  .photo-simulator {
    img {
      border-bottom: 4px solid #000;
    }
  }
}



.txt-center  {
  text-align: center;
}



.orderbump {

  .showclose {
    display: none;
  }

  .active {
    background:#0ab26e;
    color: #000;

    .showclose {
      display: inline;
    }
  }
}
</style>
